import { getDataForChart } from './get-data-for-chart';

onmessage = function listener(e) {
  const { data } = e;
  const result = getDataForChart(data);
  postMessage(result);
};
